// @ts-nocheck
import { PageBlockTypes as p } from '@xprog/prensa/types'

import { teasers as T } from '../teasers'

export const LayoutRadio: p.SlotConfigProps = {
  css: {
    column: {
      align: ['row', 'left', 'top'],
      px: '$0',
      width: '100%'
    }
  },
  slotConfig: {
    TemplateSideBoxRadio: {
      slotLeft: {
        default: [T.TeaserRadio, T.TeaserRadio]
      }
    }
  }
}